import React from "react";
import { Link, useNavigate } from "react-router-dom";
import InfoBox from "common-ui-components/components/info-box/InfoBox";
import Table from "common-ui-components/components/table/Table";
import InfoBoxRedirectButton from "app/common/InfoBoxRedirectButton";
import styles from "./ThreatsDashboardPanels.module.css";

const normalize = (value) => String(value || "").trim().toLowerCase();

const HighPriorityVulnerabilitiesPanel = ({ data }) => {
  const navigate = useNavigate();
  const columns = [
    {
      title: "CVE ID",
      accessor: "cveId",
      WrapperComponent: ({ record, children }) => (
        <Link
          className="link"
          to={`/app/secure/threats/vulnerabilities/cve-details?cveId=${encodeURIComponent(record.cveId || "")}`}
          state={{ orgVulnerabilityId: record.orgVulnerabilityId }}
        >
          {children}
        </Link>
      ),
    },
    { title: "Vulnerable Software", accessor: "vulnerableSoftware" },
    {
      title: "Severity",
      accessor: "severity",
      WrapperComponent: ({ record, children }) => (
        <span className={`${styles.severity} ${styles[normalize(record.severity)]}`}>
          {children}
        </span>
      ),
    },
    { title: "CVSS", accessor: "cvssScore" },
    { title: "Exploit Score", accessor: "exploitScore" },
    { title: "Published", accessor: "publishedDate" },
    { title: "Endpoints", accessor: "count" },
  ];

  return (
    <InfoBox
      header="High Priority Vulnerabilities"
      subtitle="Highest severity findings requiring attention"
      badge={
        <InfoBoxRedirectButton
          onClick={() => navigate("/app/secure/threats/vulnerabilities")}
          label="View all high priority vulnerabilities"
        />
      }
      badgeProps={{ className: styles.viewAllBadge }}
      className={styles.panel}
      childrenProps={{ className: styles.tableContent }}
    >
      <div className={styles.tableViewport}>
        <Table
          columns={columns}
          records={data.records}
          total={data.loading ? null : data.total}
          skeletonRowCount={5}
          borders={{ borderRadius: "0.75rem", borderColor: "#e2e8f0" }}
          cellPadding="0.8rem"
        />
      </div>
    </InfoBox>
  );
};

export default HighPriorityVulnerabilitiesPanel;
